const formValidation = require('../components/formValidation');
const DependantInput = require('../components/forms/DependantInput');
const dataLayer = require('../dataLayer/dataLayer');
const googleCaptcha = require('../googleCaptcha');
const isCaptchaEnable = googleCaptcha.isCaptchaEnable();
const cleave = require('../components/cleave');
/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    $('.js-error-messages').append(`<div class="alert alert-danger">${message}</div>`);
}

module.exports = {
    login() {
        if (isCaptchaEnable) {
            googleCaptcha.init.call(this);
        }

        $('form.login').submit((e) => {
            const $form = $(e.target);
            e.preventDefault();
            const url = $form.attr('action');
            $form.spinner().start();

            const isSuccessCaptcha = googleCaptcha.checkReCaptchaStatus.call(this);
            if (!isSuccessCaptcha && isCaptchaEnable) {
                $form.spinner().stop();
                return false;
            }

            $form.trigger('login:submit', e);

            if (isCaptchaEnable) {
                googleCaptcha.cleanErrorMessage();
            }

            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success(data) {
                    if (!data.success) {
                        if (isCaptchaEnable) {
                            googleCaptcha.resetCaptcha();
                        }

                        formValidation($form, data);
                        $form.trigger('login:error', data);
                        $('.js-login-form-password').val('');
                    } else {
                        dataLayer.loginDataLayerEventInit(data.userId);
                        $form.trigger('login:success', data);
                        window.location.href = data.redirectUrl;
                    }
                    $form.spinner().stop();
                    $form.find('#login-form-email').focus();
                },
                error(data) {
                    if (data.responseJSON.redirectUrl) {
                        window.window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        if (isCaptchaEnable) {
                            googleCaptcha.resetCaptcha();
                        }

                        $form.trigger('login:error', data);
                        $form.spinner().stop();
                        $form.find('#login-form-email').focus();
                    }
                }
            });
            return false;
        });
    },

    register() {
        if (isCaptchaEnable) {
            googleCaptcha.init.call(this);
        }

        $('form.registration').submit((e) => {
            const $form = $(e.target);
            e.preventDefault();
            const url = $form.attr('action');
            $form.spinner().start();

            const isSuccessCaptcha = googleCaptcha.checkReCaptchaStatus.call(this);
            if (!isSuccessCaptcha && isCaptchaEnable) {
                $form.spinner().stop();
                return false;
            }

            $('form.registration').trigger('login:register', e);
            if (isCaptchaEnable) {
                googleCaptcha.cleanErrorMessage();
            }
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success(data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        if (isCaptchaEnable) {
                            googleCaptcha.resetCaptcha();
                        }
                        formValidation($form, data);
                        if (data.clearPassword) {
                            $('.js-new-password').val('');
                            $('.js-confirm-password').val('');
                        }
                    } else {
                        dataLayer.loginDataLayerEventInit(data.userId);
                        window.location.href = data.redirectUrl;
                    }
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        if (isCaptchaEnable) {
                            googleCaptcha.resetCaptcha();
                        }
                        createErrorNotification(err.responseJSON.errorMessage);
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });

        document.querySelectorAll('[data-js-input-depends-from]').forEach(element =>
            new DependantInput(element).init());
    },

    resetPassword() {
        if (isCaptchaEnable) {
            this.initPasswordResetCaptcha();
        }

        // Hide feedback messages when modal opens
        $('#requestPasswordResetModal').on('dialog:open', () => {
            if (isCaptchaEnable) {
                const passwordResetRecaptcha = $('#js-g-recaptcha-password-reset');
                const passwordResetModalRecaptcha = $('#js-g-recaptcha-password-reset-modal');
                passwordResetRecaptcha.siblings('.js-g-recaptcha-feedback').hide();
                passwordResetModalRecaptcha.siblings('.js-g-recaptcha-feedback').hide();
            }
        });

        $('.reset-password-form').submit((e) => {
            e.preventDefault();
            const $form = $(e.target);
            const url = $form.attr('action');
            $form.trigger('login:register', e);
            $form.spinner().start();

            const isSuccessCaptcha = this.checkPasswordResetReCaptchaStatus();
            if (!isSuccessCaptcha && isCaptchaEnable) {
                $form.spinner().stop();
                return false;
            }

            if (isCaptchaEnable) {
                googleCaptcha.cleanErrorMessage();
            }

            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function(data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        if (isCaptchaEnable) {
                            this.resetPasswordResetCaptcha();
                        }
                        formValidation($form, data);
                    } else {
                        const $title = $('#requestPasswordResetModal').find('.request-password-title'),
                            $body = $('.request-password-body'),
                            $btn = $('#submitEmailButton'),
                            titleText = $title.text(),
                            bodyHtml = $body.html(),
                            btnText = $btn.text();

                        $title.text(data.receivedMsgHeading);
                        $body.empty()
                            .append(`<p class="b-form_reset_password-message">${data.receivedMsgBody}</p>`);
                        $btn.addClass('m-green');
                        if (!data.mobile) {
                            $btn.text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html(`<a href="${data.returnUrl}" class="btn btn-primary btn-block">${
                                    data.buttonText}</a>`);
                        }

                        $('#requestPasswordResetModal')[0].addEventListener('dialog:closed', () => {
                            $title.text(titleText);
                            $body.html(bodyHtml);

                            if (!data.mobile) {
                                $btn.text(btnText)
                                    .removeAttr('data-dismiss');
                            }
                        });
                    }
                }.bind(this),
                error: function(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        if (isCaptchaEnable) {
                            this.resetPasswordResetCaptcha();
                        }
                    }
                    $form.spinner().stop();
                }.bind(this)
            });
            return false;
        });
    },

    trackOrder() {
        $('form.trackorder').submit((e) => {
            const $form = $(e.target);
            e.preventDefault();
            const url = $form.attr('action');
            $form.spinner().start();
            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                data: $form.serialize(),
                success(data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        $('.js-order-number-error').text(data.errorMsg).show();
                        $('.js-track-order-number').addClass('is-invalid');
                    } else {
                        $('.js-order-number-error').text('');
                        $('.js-track-order-number').removeClass('is-invalid');
                        $form.attr('method', 'POST');
                        $form.attr('action', data.redirectUrl);
                        $form.off();
                        $('.js-submit-form-button').click();
                    }
                }
            });
            return false;
        });
    },
    guestLogin() {
        $('.js-checkout-as-guest-form').on('submit', (e) => {
            e.preventDefault();

            const $form = $(e.target);
            const $email = $('.js-checkout-as-guest-email');
            const $isGlobalOptIn = $('#newsletter-conditions-and-privacy');
            const email = $email.length && !$email.hasClass('is-invalid') && $email.val();
            const isGlobalOptIn = $isGlobalOptIn.length && !$isGlobalOptIn.hasClass('is-invalid') && $isGlobalOptIn.prop('checked');

            if (email) {
                $.spinner().start();

                var actionURL = $form.attr('action'),
                    requestData = {
                        email: email,
                        isGlobalOptIn: isGlobalOptIn
                    };

                $.ajax({
                    url: actionURL,
                    data: requestData,
                    method: 'GET',
                    success(data) {
                        if (data && data.status && data.status === 'success') {
                            window.location = $form.data('nextStep');
                        } else if (data && data.errorMessage) {
                            $('.js-error-messages-email').show().text(data.errorMessage);
                        }
                    },
                    error(err) {
                        $('.js-error-messages-email').show().text(err.responseJSON.errorMessage);
                    },
                    complete() {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    clearFieldAfterClosing () {
        $('#requestPasswordResetModal').on('dialog:closed', () => {
            $('#reset-password-email').val('');
            if (isCaptchaEnable) {
                this.resetPasswordResetCaptcha();
            }
        });
    },

    // Used to make PostalCode value Uppercase
    updatePostalCode() {
        $('.js-shipping-postal-code').on('input', (e) => {
            var $currentTarget = $(e.currentTarget);

            $currentTarget.val($currentTarget.val().toUpperCase());
            cleave.handlePostalCode($currentTarget);
        });
    },

    initPasswordResetCaptcha() {
        const passwordResetRecaptcha = $('#js-g-recaptcha-password-reset');
        const passwordResetModalRecaptcha = $('#js-g-recaptcha-password-reset-modal');

        this.passwordResetReCaptchaSuccess = false;

        const verifyCallback = () => {
            this.passwordResetReCaptchaSuccess = true;
            passwordResetRecaptcha.siblings('.js-g-recaptcha-feedback').hide();
            passwordResetModalRecaptcha.siblings('.js-g-recaptcha-feedback').hide();
        };

        const expiredCallback = () => {
            setTimeout(() => {
                if (window.grecaptcha) {
                    window.grecaptcha.reset();
                }
                this.passwordResetReCaptchaSuccess = false;
            }, 0);
        };

        window.onloadPasswordResetCallback = function () {
            if (passwordResetRecaptcha.length > 0 && passwordResetRecaptcha.html() === '') {
                const recaptchaRef = window.grecaptcha.render(passwordResetRecaptcha[0], {
                    sitekey: passwordResetRecaptcha.data('sitekey'),
                    callback: verifyCallback,
                    'expired-callback': expiredCallback
                });
                passwordResetRecaptcha.data('recaptcha-ref', recaptchaRef);
            }

            if (passwordResetModalRecaptcha.length > 0 && passwordResetModalRecaptcha.html() === '') {
                const recaptchaRef = window.grecaptcha.render(passwordResetModalRecaptcha[0], {
                    sitekey: passwordResetModalRecaptcha.data('sitekey'),
                    callback: verifyCallback,
                    'expired-callback': expiredCallback
                });
                passwordResetModalRecaptcha.data('recaptcha-ref', recaptchaRef);
            }
        };

        $('.reset-password-form').find('.cb-error-message').hide();
        passwordResetRecaptcha.siblings('.js-g-recaptcha-feedback').hide();
        passwordResetModalRecaptcha.siblings('.js-g-recaptcha-feedback').hide();
        const locale = $('.js-locale').data('locale').replace('_', '-');
        const scriptTag = document.createElement('script');
        scriptTag.setAttribute('src', '//www.google.com/recaptcha/api.js?onload=onloadPasswordResetCallback&render=explicit&hl=' + locale);
        document.getElementsByTagName('body')[0].appendChild(scriptTag);
    },

    checkPasswordResetReCaptchaStatus() {
        const passwordResetRecaptcha = $('#js-g-recaptcha-password-reset');
        const passwordResetModalRecaptcha = $('#js-g-recaptcha-password-reset-modal');

        passwordResetRecaptcha.siblings('.js-g-recaptcha-feedback').hide();
        passwordResetModalRecaptcha.siblings('.js-g-recaptcha-feedback').hide();

        if (!this.passwordResetReCaptchaSuccess) {
            passwordResetRecaptcha.siblings('.js-g-recaptcha-feedback').show();
            passwordResetModalRecaptcha.siblings('.js-g-recaptcha-feedback').show();
            return false;
        }
        return true;
    },

    resetPasswordResetCaptcha() {
        if (window.grecaptcha) {
            const passwordResetRecaptcha = $('#js-g-recaptcha-password-reset');
            const passwordResetModalRecaptcha = $('#js-g-recaptcha-password-reset-modal');

            if (passwordResetRecaptcha.length > 0 && passwordResetRecaptcha.data('recaptcha-ref') !== undefined) {
                window.grecaptcha.reset(passwordResetRecaptcha.data('recaptcha-ref'));
            }

            if (passwordResetModalRecaptcha.length > 0 && passwordResetModalRecaptcha.data('recaptcha-ref') !== undefined) {
                window.grecaptcha.reset(passwordResetModalRecaptcha.data('recaptcha-ref'));
            }

            this.passwordResetReCaptchaSuccess = false;
        }
    }
};
